<template>
  <div class="orders">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Orders',
};
</script>
